<template>
  <div class="table">
    <table class="table table-striped table-hover">
      <thead>
      <tr>
        <th class="content">商品</th>
        <th class="spe">商品规格</th>
        <th class="num">退货数量</th>
        <th class="order-state">售后状态</th>
      </tr>
      </thead>
      <tbody style="width:100%; text-align:center; font-size:16px; height: 300px; line-height: 250px"
             v-if="list.length <= 0">暂无售后商品列表
      </tbody>
      <tbody v-else>
      <template v-for="(item,index) in list">
        <tr class="tbody-null"></tr>
        <tr class="tbody-head" :key="index">
          <span class="date">{{ item.create_time }}</span>
          <span class="orderhao">售后单号:{{ item.aftersale_code }}</span>
          <span style="float: right; padding-right: 10px">
            <el-button type="text" style="color: #003871" @click="lookOver(item.aftersale_code)">查看</el-button>
            <el-button v-if="item.status === 0" type="text" style="color: #003871"
                       @click="revocation(item.aftersale_code)">撤销</el-button>
          </span>
        </tr>

        <tr class="tbody-main" v-for="(i, j) in item.item" :key="j">
          <td class="content" style="margin-left: unset">
            <div class="right">
              <p class="text">{{ i.goods_name }}</p>
              <p class="number" @click="goxqs(i.goods_code)">{{ i.goods_code }}</p>
            </div>
          </td>
          <td class="spe">
            <span>{{ i.sku }}</span>
          </td>
          <td class="num">
            <span>{{ i.return_number }}</span>
          </td>
          <td class="order-state">
            {{ i.status_name }}
          </td>
        </tr>
      </template>
      </tbody>
    </table>

    <el-dialog
        title="售后服务明细"
        :visible.sync="dialogVisible"
        width="65%">

      <div class="main-table">
        <label>退货单号：</label><span>{{ detailList.data.aftersale_code }}</span>
        <label>销售单号：</label><span>{{ detailList.data.order_code }}</span>
        <label>退货状态：</label><span>{{ detailList.data.status_name }}</span>
        <label>退货原因：</label><span>{{ detailList.data.reason }}</span>
        <label>申请时间：</label><span>{{ detailList.data.create_time }}</span>
        <p><label>备注信息：</label><span>{{ detailList.data.remark }}</span></p>
        <table>
          <thead>
          <tr>
            <th>订单详情</th>
            <th>规格</th>
            <th>申请数量</th>
            <th>实退数量</th>
            <th>状态</th>
          </tr>
          </thead>
          <tbody>
          <div v-for="(item,index) in detailList.data.item" :key="index">
            <tr>
              <td>
                <div @click="goxqs(item.goods_code)">
                  <p>{{ item.goods_name }}</p>
                  <p class="good-code">{{ item.goods_code }}</p>
                </div>
              </td>
              <td>{{ item.sku }}</td>
              <td>{{ item.return_number }}</td>
              <td>{{ item.real_number }}</td>
              <td>{{ item.status_name }}</td>
            </tr>
            <div class="attribute">

            </div>
          </div>
          </tbody>
        </table>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
export default {
  props: ["list"],
  data() {
    return {
      dialogVisible: false,
      detailList: {
        data: {
          item: []
        }
      }
    };
  },
  methods: {
    goxqs(id) {
      this.$router.push({
        path: `/homepage/detail`,
        query: {
          id: id
        }
      });
    },
    lookOver(aftersale_code) {
      this.$api.tryApply.lookOver({
        code: aftersale_code
      }).then((res) => {
        this.dialogVisible = true;
        this.detailList = res;
      })
    },
    revocation(aftersale_code) {
      this.$api.tryApply.revocation({
        code: aftersale_code
      }).then((res) => {
        if (res.status === 1) {
          this.$message({
            showClose: true,
            message: '退货订单撤销成功',
            type: 'success'
          });
          location.reload()
        } else {
          this.$message({
            showClose: true,
            message: res.msg,
            type: 'warning'
          });
        }
      })
    }
  },
};
</script>

<style lang="less" scoped>
table {
  border-collapse: collapse;
}

thead {
  width: 876px;
  height: 58px;
  background: #f5f5f5;

  tr {
    display: flex;
    line-height: 58px;
    font-size: 15px;
    color: #000
  }
}

tbody {
  .tbody-null {
    height: 10px;
  }

  .tbody-head {
    height: 38px;
    background: #f5f5f5;
    border-top: none;
    line-height: 38px;

    .date {
      padding-left: 21px;
    }

    .orderhao {
      padding-left: 70px;
    }
  }

  .tbody-main {
    width: 876px;
    min-height: 80px;
    border: 1px solid #dddddd;
    border-top: none;
    background: #fff;
    display: flex;
    align-items: center;

    .pay-state:hover {
      width: 72px;
      color: #ffbb00;
      cursor: pointer;
      text-decoration: underline;
    }

    .colspan {
      display: flex;
    }
  }
}

.number {
  color: #a52a2a;
  cursor: pointer;
}

thead tr,
.tbody-main {
  text-align: center;

  .content {
    width: 550px;
    padding-left: 20px;
    text-overflow: ellipsis;
    display: inline-block;
    text-align: left;
  }

  .num {
    width: 100px;
  }

  .spe {
    width: 100px;
  }

  .person {
    width: 100px;
  }

  .pay-state {
    width: 100px;
    cursor: pointer;
  }

  .pay-state {
    width: 100px;
  }

  .order-state {
    width: 100px;
  }
}

.main-table {
  width: 100%;
  margin: auto;

  table {
    width: 100%;
    min-height: 116px;
    margin-top: 20px;

    tr {
      display: flex;
      align-items: center;
    }

    th {
      text-align: left;
    }

    th,
    td {
      &:nth-child(1) {
        width: 630px;
        padding-left: 20px;
      }

      &:nth-child(2) {
        width: 120px;
      }

      &:nth-child(3) {
        width: 150px;
      }

      &:nth-child(4) {
        width: 150px;
      }

      &:nth-child(5) {
        width: 150px;
      }
    }
  }

  thead {
    width: 100%;
    min-height: 38px;
    background: #f5f5f5;
    border: 1px solid #dddddd;

    tr {
      width: 100%;
      min-height: 38px;
    }
  }

  tbody {
    tr {
      width: 100%;
      min-height: 60px;
      border: 1px solid #dddddd;
      border-top: none;
      border-bottom: none
    }
  }

  label {
    font-weight: bold;
  }

  span {
    margin-right: 32px;
  }
}

.newPrice {
  .old {
    text-decoration: line-through;
    display: block;
  }

  .new {
    color: #a52a2a;
  }
}

.good-code {
  color: #a52a2a;
  text-decoration-line: underline;
  cursor: pointer;
}

.attribute {
  border: 1px solid #ccc;
  border-top: none;

  p {
    padding: 15px;
  }

  span {
    margin-right: 20px;

    span {
      color: #999
    }
  }
}
</style>
